import React from 'react';

/**
 * RecommendedModelCard
 * Reuses the same "app card" styling as local models, but tailored to recommended metadata.
 */
function RecommendedModelCard({ model, onCardClick }) {
  if (!model) return null;

  const handleCardClick = () => {
    onCardClick?.(model);
  };

  const quantizationText = model.quantization ? `Quant: ${model.quantization}` : 'Quant: —';
  const sizeText = typeof model.fileSize === 'string' && model.fileSize.trim().length > 0 ? model.fileSize : '—';
  const badgeText = model.badge ? 'Recommended' : null;

  return (
    <div
      className={`model-card grid-card active`}
      onClick={handleCardClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleCardClick();
      }}
    >
      <div className="model-card-header">
        <h3 className="model-card-title">{model.displayName}</h3>
        {badgeText ? (
          <span className="model-card-status active">{badgeText}</span>
        ) : (
          <span className="model-card-status" style={{ opacity: 0 }} aria-hidden />
        )}
      </div>

      <div className="model-card-meta-row">
        <span className="recommended-model-meta-left">{quantizationText}</span>
        <span className="recommended-model-meta-right">{sizeText}</span>
      </div>
    </div>
  );
}

export default RecommendedModelCard;

